module.exports = __webpack_public_path__ + "img/noor.d31efaca.svg";